import {html} from "./utils/environment";

console.log("Started JS App");

html.classList.add("is-loaded");
html.classList.add("is-ready");
html.classList.remove("is-loading");

import anchorLink from "./components/anchor-link";
import aygSlider from "./components/ayg-slider";
import floatingBtn from "./components/floating-btn";

document.addEventListener("DOMContentLoaded", function () {
    anchorLink();
    aygSlider();
    floatingBtn();
});
